export const RECEIVE_INPUTS = "RECEIVE_INPUTS";

export const receiveInputs = inputs => ({
    type: RECEIVE_INPUTS,
    inputs
});